// extracted by mini-css-extract-plugin
module.exports = {"boardGrid__modal":"BoardModal_boardGrid__modal__3DkW0","inputContainer":"BoardModal_inputContainer__2xfAl","btn__container":"BoardModal_btn__container__39D8I"};